import { useQuery } from "@tanstack/react-query";
import { ObjectQueriesTags } from "../../api/object";
import { getObjects } from "../api/get-objects";

interface IUseGetObjects {
  page?: number;
  limit?: number;
  projectId?: string;
}

export function useObjects({
  page = 1,
  limit = 1000,
  projectId = "",
}: IUseGetObjects) {
  return useQuery({
    queryFn: () => getObjects({ projectId, page, limit }),
    queryKey: ObjectQueriesTags.getAllObjects({ projectId } as {
      projectId: string;
    }),
    enabled: !!projectId,
  });
}
